import { sizedIconUrl } from '@mm/shared';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

/** App logo (Google Play icon) with a letter fallback when missing or broken. */
export function AppIcon({
  src,
  name,
  size = 36,
  className,
}: {
  src: string | null | undefined;
  name: string;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const valid = !!src && /^https:\/\//.test(src) && !failed;

  return valid ? (
    <img
      src={sizedIconUrl(src, size * 2)}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={clsx(
        'shrink-0 rounded-[22%] border border-slate-200 bg-white object-cover',
        className,
      )}
      style={{ width: size, height: size }}
    />
  ) : (
    <span
      aria-hidden
      className={clsx(
        'flex shrink-0 items-center justify-center rounded-[22%] bg-slate-100 font-semibold text-slate-500',
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.42 }}
    >
      {(name ?? '').trim().charAt(0).toUpperCase() || '?'}
    </span>
  );
}

/** Small overlapping logos for the apps using an account (max 3 + count). */
export function AppIcons({
  apps,
  size = 22,
}: {
  apps: { id: string; name: string; iconUrl: string | null }[];
  size?: number;
}) {
  if (!apps.length) return null;
  const shown = apps.slice(0, 3);
  return (
    <span className="flex shrink-0 items-center" title={apps.map((a) => a.name).join(', ')}>
      {shown.map((a, i) => (
        <AppIcon
          key={a.id}
          src={a.iconUrl}
          name={a.name}
          size={size}
          className={clsx(i > 0 && '-ml-2 ring-2 ring-white')}
        />
      ))}
      {apps.length > shown.length && (
        <span className="ml-1 text-xs text-slate-500">+{apps.length - shown.length}</span>
      )}
    </span>
  );
}
